import { render, staticRenderFns } from "./file-list-item.vue?vue&type=template&id=304afb99&scoped=true"
import script from "./file-list-item.vue?vue&type=script&lang=js"
export * from "./file-list-item.vue?vue&type=script&lang=js"
import style0 from "./file-list-item.vue?vue&type=style&index=0&id=304afb99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304afb99",
  null
  
)

export default component.exports